import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { redirectInterceptor } from '../redirect.interceptor';
import { mockInterceptor } from '../mock.interceptor';
import { environment } from '../../environments/environment';
import {headersInterceptor} from "../headers.interceptor";

export const httpProviders = [
    provideHttpClient(
        withInterceptors([
            ...(environment.useMocks ? [mockInterceptor] : []),
            redirectInterceptor,
            headersInterceptor
        ])
    )
];